import { componentIsSearch } from './Pages/Search/current-page-is-search';
import { HIDE_QUICKSEARCH, SHOW_QUICKSEARCH, UPDATE_QUICKSEARCH_TEXT, UPDATE_QUICKSEARCH_COMPLETIONS, UPDATE_SELECTED_QUICKSEARCH_COMPLETION, UPDATE_QUICKSEARCH_CART, CLEAR_QUICKSEARCH_CART, CLOSE_QUICKSEARCH, SEARCH_HISTORY_LIST_ID, POPULAR_SEARCHES_LIST_ID, SUGGESTIONS_LIST_ID, } from './action-creators';
import { PAGE_LOAD_DONE, PAGE_LOAD } from 'SiteLayout/CurrentPage/action-creators';
import { parseUrl } from 'Shared/url';
export default function (state = null, action, currentPage, appShellData) {
    if (state === null) {
        state = {
            isOpen: false,
            isListOpen: false,
            searchText: getSearchTextFromCurrentPage(currentPage) || '',
            suggestion: null,
            completionsLists: [],
            cartItems: [],
            selectedCompletionIndex: -1,
            selectedCompletionType: 'product',
            originalSearchTerm: null,
            searchPage: appShellData.mainSearchPage,
            totalItems: 0
        };
    }
    switch (action.type) {
        case HIDE_QUICKSEARCH: {
            const hideAction = action;
            const suggestion = hideAction.setFirstSuggestionAsSearchText
                ? getQuerySuggestion(state.searchText, state.completionsLists, 0)
                : state.searchText;
            return Object.assign({}, state, {
                isOpen: false,
                searchText: suggestion || state.searchText,
                suggestion: null,
                cartItems: [],
            });
        }
        case CLOSE_QUICKSEARCH: {
            return Object.assign({}, state, {
                isOpen: false,
                searchText: '',
                suggestion: null,
                cartItems: [],
            });
        }
        case SHOW_QUICKSEARCH: {
            return Object.assign({}, state, {
                isOpen: true,
                searchPage: appShellData.mainSearchPage
            });
        }
        case PAGE_LOAD: {
            return Object.assign({}, state, {
                isOpen: false,
                searchText: '',
                suggestion: null,
                cartItems: [],
            });
        }
        case PAGE_LOAD_DONE: {
            const loadDoneAction = action;
            const query = getSearchTextFromCurrentPage(currentPage);
            if (query !== null && !state.isOpen) {
                return Object.assign({}, state, {
                    searchText: query,
                    suggestion: null,
                    cartItems: [],
                });
            }
            else if (!componentIsSearch(currentPage.componentName) && !loadDoneAction.serverRedirected) {
                // We don't want to clear the search text if the current component isn't the search page
                // because the server might redirect us from the search page to a brand page if the user
                // searched for a brand
                return Object.assign({}, state, {
                    searchText: '',
                    suggestion: null,
                    cartItems: [],
                });
            }
            break;
        }
        case UPDATE_SELECTED_QUICKSEARCH_COMPLETION: {
            let index = action.index;
            let type = action.selectionType;
            const text = state.originalSearchTerm || state.searchText;
            const suggestion = type === 'item' ? getQuerySuggestion(text, state.completionsLists, index) : text;
            return Object.assign({}, state, {
                selectedCompletionIndex: index,
                selectedCompletionType: type,
                searchText: text,
                suggestion: suggestion || text,
            });
        }
        case UPDATE_QUICKSEARCH_TEXT: {
            let { searchText } = action;
            const suggestion = getQuerySuggestion(searchText, state.completionsLists, 0);
            return Object.assign({}, state, {
                searchText,
                suggestion,
                selectedCompletionIndex: -1,
                originalSearchTerm: searchText,
            });
        }
        case UPDATE_QUICKSEARCH_COMPLETIONS: {
            const completionsAction = action;
            const newState = Object.assign({}, state, {
                completionsLists: completionsAction.lists,
                totalItems: completionsAction.totalItems
            });
            const newListIds = completionsAction.lists.map(l => l.id);
            newState.completionsLists = newState.completionsLists
                .concat(state.completionsLists.filter(l => newListIds.indexOf(l.id) === -1))
                .sort(sortLists);
            return newState;
        }
        case UPDATE_QUICKSEARCH_CART: {
            const cartAction = action;
            let stateCartItems = state.cartItems.filter(i => i.code !== cartAction.code);
            if (cartAction.quantity && cartAction.quantity > 0) {
                stateCartItems.push({
                    code: cartAction.code,
                    quantity: cartAction.quantity,
                    unitShortName: cartAction.unitShortName,
                    ticket: cartAction.ticket,
                });
            }
            const newState = Object.assign({}, state, {
                cartItems: stateCartItems,
            });
            return newState;
        }
        case CLEAR_QUICKSEARCH_CART: {
            return Object.assign({}, state, {
                cartItems: [],
            });
        }
        default:
            break;
    }
    return state;
}
export function getQuerySuggestion(currentQuery, lists, index) {
    const firstNonEmptyList = lists.filter(l => !!l.items && l.items.length > 0)[0];
    if (!firstNonEmptyList) {
        return null;
    }
    const firstAutocomplete = index === 0 ? firstNonEmptyList.items[index].text : getCompletionAtIndex(index, lists);
    if (!firstAutocomplete || !currentQuery || currentQuery[currentQuery.length - 1] === ' ') {
        return currentQuery;
    }
    const currentWords = currentQuery.split(' ').filter(s => !!s);
    const autocompleteWords = firstAutocomplete.split(' ').filter(s => !!s);
    if (currentWords.length > autocompleteWords.length) {
        return currentQuery;
    }
    const lastIndex = currentWords.length - 1;
    for (let i = 0; i < lastIndex; i++) {
        if (currentWords[i].toLowerCase() !== autocompleteWords[i].toLowerCase()) {
            return currentQuery;
        }
    }
    if (!autocompleteWords[lastIndex].toLowerCase().startsWith(currentWords[lastIndex].toLowerCase())) {
        return currentQuery;
    }
    return currentQuery + autocompleteWords[lastIndex].substr(currentWords[lastIndex].length);
}
const listOrder = [SUGGESTIONS_LIST_ID, SEARCH_HISTORY_LIST_ID, POPULAR_SEARCHES_LIST_ID];
function sortLists(a, b) {
    return listOrder.indexOf(a.id) - listOrder.indexOf(b.id);
}
function getCompletionAtIndex(index, lists) {
    if (index > 0) {
        return lists.reduce((a, b) => a.concat(b.items), [])[index].text;
    }
    return '';
}
function getSearchTextFromCurrentPage(currentPage) {
    if (componentIsSearch(currentPage.componentName)) {
        const currentUrl = parseUrl(window.location);
        return getSearchTextFromUrl(currentUrl);
    }
    else {
        return null;
    }
}
export function getSearchTextFromUrl(url) {
    return url && url.query ? url.query['q'] || '' : '';
}
